import { FC } from "react";
import Dashboardui from "src/components/dashboard/Dashboardui";

const Home: FC = () => {
  return <>
  <Dashboardui/>
  </>;
};

export default Home;
